import React from 'react'

const CustomerApp = () => {
  return (
    <></>
  )
}

export default CustomerApp